import PropTypes from 'prop-types';
import React, { Component } from 'react';
import PageLoader from './PageLoader';

/**
 * /callback target for the Auth0 authorization-code flow.
 *
 * The actual code exchange happens in AuthService.init() (called from App.componentDidMount)
 * before routes render, so this component only has to show a loader. If someone lands here
 * without a `code` or `error` in the query there is nothing to exchange, so send them to /auth.
 */
class AuthCallback extends Component {
  componentDidMount() {
    const { history, location } = this.props;
    const params = new URLSearchParams(location.search);
    if (!params.has('code') && !params.has('error')) {
      history.replace('/auth');
    }
  }

  render() {
    return (
      <PageLoader />
    );
  }
}

AuthCallback.propTypes = {
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
};

export default AuthCallback;
